import React from 'react';
import {observer} from 'mobx-react';
import {Input, FormLayout, Panel, RadioButton, RadioButtonGroup} from 'shared/components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';

 const PolicyDetails = observer(({uiState}) => {
  const {policy, errors} = uiState;

   return (
    <div>
      <Panel.Header
        title={t('time_tracking.manage.policies.edit.Policy Details')}
        description={t("time_tracking.manage.policies.edit.Start by setting up the basic details of your policy.")}
      />
      <FormLayout>
        <Input
          value={policy.name}
          label='time_tracking.manage.policies.edit.Policy Name'
          onChange={e => policy.merge({name: e.target.value})}
          errorMessage={errors.name}
        />
        <RadioButtonGroup
          name='manuallyEnterHours'
          label='time_tracking.manage.policies.edit.How should employees enter their time?'
          selectedValue={policy.manuallyEnterHours}
          onChange={(name, value) => policy.merge({manuallyEnterHours: value})}
        >
          <RadioButton className='block' value={false}>
            <FormattedMessage id='time_tracking.manage.policies.edit.Start and End Time'/>
          </RadioButton>
          <RadioButton className='block' value={true}>
            <FormattedMessage id='time_tracking.manage.policies.edit.Total Hours'/>
          </RadioButton>
        </RadioButtonGroup>
      </FormLayout>
    </div>
  );
});

 export default PolicyDetails;
